export default defineNuxtPlugin({
    enforce: 'post',
    async setup({ $bus }) {
        if (process.client) {
            window.addEventListener('footer-newsletter-subscription', (event) => {
                console.log('Custom event received:', event.detail)
                const result = event.detail
                const type = result.isSubscriptionAlreadySubscribed ? 'error' : 'success'

                $bus.$emit('notification', {
                    message: result.message,
                    type,
                })
            })
        }
    },
})
